interface Props {
  value: number | null | undefined;
  unit?: string;
  /** True when a rise is bad (incidents, MTTR). Default: a rise is good. */
  invert?: boolean;
  decimals?: number;
}

export function DeltaValue({ value, unit = '', invert = false, decimals = 2 }: Props) {
  if (value === null || value === undefined) return null;
  if (value === 0) return <span className="text-gray-500 text-xs">no change</span>;

  const good = invert ? value < 0 : value > 0;
  const arrow = value > 0 ? '▲' : '▼';
  return (
    <span
      className={`text-xs font-medium ${good ? 'text-status-up' : 'text-status-down'}`}
      aria-label={`${value > 0 ? 'up' : 'down'} ${Math.abs(value).toFixed(decimals)}${unit} versus previous period`}
    >
      {arrow} {Math.abs(value).toFixed(decimals)}{unit}
    </span>
  );
}
